// 统一请求路径前缀在commmon/axios.js中修改
import { postDemo, getDemo, deleDemo, deleDemos, getRequest, postRequest, postRequestLogin, putRequest, putNoToken, getRequestWithNoToken } from '../assets/js/api';

/**
 * 获取消息类型列表接口
 * @param No
 */
export const _getMessageList = (params) => {
    return getRequest('/api-message/message/type/list', params)
}

/**
 * 接收消息接口
 *
  "asc": false,
  "currentPage": 0,
  "orderByField": "string",
  "pageSize": 0,
  "queryData": {
    "createTimeEnd": "2021-08-27T01:55:48.801Z",
    "createTimeStart": "2021-08-27T01:55:48.801Z",
    "readed": 0,
    "receiveId": "string",
    "receiveSys": 0,
    "sendType": 0,
    "title": "string",
    "type": 0
  }
 */
export const _getMessageReceive = (params) => {
    return postRequest('/api-message/message/receive', params)
}

/**
 *消息已读接口
 * @param No
 */
export const _messageReaded = (params) => {
    return postRequest('/api-message/message/read', params)
}
/**
 *查看问卷发布配置
 * @param No
 */
export const _projectSetting = (id, params) => {
    return getRequest(`/api-customer-c/questionnaire/questionnaireSetting/${id}`, params)
}
